/**
 * Encodes UTF-8 text to base64url (RFC 4648 §5).
 */
export function toBase64Url(str) {
  let binary = '';

  if (typeof TextEncoder !== 'undefined') {
    const bytes = new TextEncoder().encode(String(str));
    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });
  } else {
    binary = encodeURIComponent(String(str)).replace(
      /%([0-9A-F]{2})/g,
      (_, hex) => String.fromCharCode(parseInt(hex, 16))
    );
  }

  return btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

function isAndroid() {
  return /Android/i.test(navigator.userAgent);
}

export function buildGoogleCalendarUrl(event) {
  const fmt = (iso) => iso.replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.summary,
    dates: `${fmt(event.start)}/${fmt(event.end)}`,
  });
  if (event.description) params.set('details', event.description);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/**
 * Navigate directly to backend calendar generator endpoint.
 * This works reliably on iOS Safari where blob downloads can be flaky.
 * On Android, opens Google Calendar directly for a seamless one-tap save flow.
 */
export function openCalendar(event) {
  if (isAndroid()) {
    window.open(buildGoogleCalendarUrl(event), '_blank');
    return;
  }
  const payload = toBase64Url(JSON.stringify(event));
  const href = `/plugin/vmc/calendar/generate?payload=${payload}`;
  window.location.href = href;
}
